export default __webpack_public_path__ + "static/media/wave_image.617e5160.png";